// extracted by mini-css-extract-plugin
module.exports = {"SecondSection":"SecondSection_SecondSection__3TGsU","Header":"SecondSection_Header__rA0_g","Image":"SecondSection_Image__9QCO6","Description":"SecondSection_Description__1u073"};